import { ValidationMail } from 'src/app/tools/api.service';

export class Validationmail {
    idvalidationMail?:number;
    location?:string;
    rTmail?:string;
    rTname?:string;
    login?:string;
    city?:string;

    public static parseToValidationmail(item: Validationmail): ValidationMail {
        let result = new ValidationMail();
        result.idvalidationMail = item.idvalidationMail;
        result.location = item.location;
        result.rTmail = item.rTmail;
        result.rTname = item.rTname;
        result.login = item.login;
        result.city = item.city;
        return result;
    }
}
